import { render, staticRenderFns } from "./WonderJy96.vue?vue&type=template&id=960ea946"
import script from "./WonderJy96.vue?vue&type=script&lang=js"
export * from "./WonderJy96.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports